import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteAnaliseMercadoClassificacaoSearchLancamentosFilter } from '../cliente-analise-mercado-classificacao-search-lancamentos-filter';
import { ClienteAnaliseMercadoClassificacaoSearchLancamento } from '../cliente-analise-mercado-classificacao-search-lancamento';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoClassificacaoLancamentoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisemercado/classificacao/lancamento`;
    }

    /** Pesquisa as análises das classificações do cliente e ano informados */
    search(perspectiva: number, idCliente: number, periodicidade: number, periodicidadeAtual: boolean, mes: number, trimestre: number, semestre: number, ano: number, filter: ClienteAnaliseMercadoClassificacaoSearchLancamentosFilter): Observable<ClienteAnaliseMercadoClassificacaoSearchLancamento[]> {
        // Params
        let params = new HttpParams().append('idCliente', idCliente ? idCliente.toString() : null);
        // Perspectiva
        if (perspectiva) {
            params = params.append('perspectiva', perspectiva.toString());
        }
        // Periodicidade
        if (periodicidade) {
            params = params.append('periodicidade', periodicidade.toString());
        }
        // Periodicidade Atual
        if (periodicidadeAtual) {
            params = params.append('periodicidadeAtual', periodicidadeAtual.toString());
        }
        // Mês
        if (mes) {
            params = params.append('mes', mes.toString());
        }
        // Trimestre
        if (trimestre) {
            params = params.append('trimestre', trimestre.toString());
        }
        // Semestre
        if (semestre) {
            params = params.append('semestre', semestre.toString());
        }
        // Ano
        if (ano) {
            params = params.append('ano', ano.toString());
        }
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteAnaliseMercadoClassificacaoSearchLancamento[]>(this.pathApi, {params});
    }
}
